import { useLocation } from "react-router-dom";
import { useEffect, useLayoutEffect } from "react";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "auto" });
    }, 3);
  }, [pathname]);
  return null;
};

export default ScrollTop;
